const CDN = "https://dpagz47n4g1lw.cloudfront.net/";

/**
 * Content blockers drop any request whose URL contains `/banner_ads/`, which
 * left the "Banner slides" cards as empty boxes while the player and artwork
 * cards rendered fine — same bytes, different folder name. This routes the
 * artwork through the API under a name no filter list matches.
 *
 * Returns the URL unchanged when it is not a CDN ad path, so it is safe to
 * apply to anything.
 */
export function adImageUrl(uri, { small = false } = {}) {
    if (!uri || uri.indexOf(CDN) !== 0) return uri;

    let path = uri.slice(CDN.length);

    // The panel only ever shows thumbnails; originals here are multi-megabyte.
    // ImageOptimizer writes _small for type 'ads', so prefer it when asked.
    if (small) {
        const dot = path.lastIndexOf(".");
        if (dot > 0) path = path.slice(0, dot) + "_small" + path.slice(dot);
    }

    // base64url — '+' and '/' would need escaping in a query string.
    const key = btoa(path)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");

    return `${process.env.REACT_APP_API_URL}/media/thumb.php?k=${key}`;
}
